export function getFieldNames(fields: Array<{ name?: string }>): string[] {
  return fields
    .map((field) => field.name)
    .filter((name): name is string => typeof name === 'string' && name.length > 0)
}
